// extracted by mini-css-extract-plugin
module.exports = {"component":"common-AuthorList__component--3eF9S"};